import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import './index.css'
import { Navbar } from '../../../Components'
import { ADMIN_API, USER_API } from '../../../functions'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import UsersList from './UsersList';
import {
  Card,
  Typography,
  CardBody,
} from "@material-tailwind/react";
import { Chip } from "@material-tailwind/react";
import { BiArrowBack } from 'react-icons/bi'
import { AiFillDelete } from 'react-icons/ai'
import Swal from 'sweetalert2'
import lottie from 'lottie-web';
import { useRef } from 'react';


const User = () => {
  const peopleIni = []
  const [showUser, setShowUser] = useState(false)
  const [detailUser, setDetailUser] = useState({});
  const navigate = useNavigate()
  const [ifLoading, setIfLoading] = useState(true)
  const [ifSuperAdmin, setIfSuperAdmin] = useState(false)

  const checkUser = async () => {
    const user = Cookies.get('user');
    if (user) {
      try {
        let res = await axios.get(`${USER_API}/getData/${user}`);
        // console.log(res)
        if (res.status === 200) {
          if (!res.data.ifAdmin) {
            navigate('/login');
          }
          else {
            if (res.data.ifSuperAdmin) {
              setIfSuperAdmin(true)
            }
          }
        }
        else {
          Cookies.remove('user');
          navigate('/login');
        }
      }
      catch (err) {
        navigate('/login');
      }
    }
    else {
      navigate('/login');
    }
  }

  useEffect(() => {
    checkUser();
  }, [])

  const StudentList = () => {

    const [people, setPeople] = useState(peopleIni)
    const TABLE_HEAD = ["Student", "Class", "City", "Edit"];


    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${ADMIN_API}/getAllStudent`);
        const data = await res.data;
        // console.log(data)
        setPeople(data.foundUser)
      }
      catch (err) {
        Swal.fire(
          'Error!',
          'Could not load users.',
          'error'
        )
      }
      finally {
        setIfLoading(false)
      }
    }
    useEffect(() => {
      fetchUsers();
    }, [])

    const handleShowUser = (person) => {
      setShowUser(true)
      setDetailUser(person)
    }

    const ref = useRef(null);

    const Loader = () => {
      useEffect(() => {
        const Animator = lottie.loadAnimation({
          container: ref.current,
          animationData: require('../../../Components/Animations/LoadingBarsRotation.json'),
          renderer: 'svg',
          loop: true,
          autoplay: true,

        });
        return () => Animator.destroy();
      }, [])


      return (
        <div className='flex flex-col justify-center items-center h-screen'>
          <div className='w-1/2' ref={ref} ></div>
        </div>
      )
    }

    if (ifLoading) {
      return <Loader />
    }
    return (
      <Card className="h-full w-full mx-2">
        <CardBody className="overflow-auto flex justify-center">
          <table className="mt-4 w-full min-w-max table-auto text-center ">
            <thead>
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th key={head}
                    className=""
                    {...(head === "City" ? {
                      className: "border-y border-blue-gray-100 bg-blue-gray-50/50 hidden md:table-cell sm:table-cell lg:table-cell"
                    } : { className: "border-y border-blue-gray-100 bg-blue-gray-50/50 p-4" })}
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="font-normal leading-none opacity-70"
                    >
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {people.map((person, index) => {
                return (
                  <UsersList key={index} ifAdmin={person.ifAdmin} ifSuperAdmin={person.ifSuperAdmin} StudentName={person.StudentName} StudentMobile={person.StudentMobile} StudentClass={person.StudentClass} StudentCity={person.StudentCity} handleShowUser={handleShowUser} value={person} />
                )
              })}
            </tbody>
          </table>
        </CardBody>
      </Card >

    )
  }

  const DetailUser = () => {
    const handleDeleteUser = async (user) => {
      try {
        const res = await axios.post(`${ADMIN_API}/deleteUser`, {
          StudentMobile: user.StudentMobile,
        })
        // console.log(res)
        if (res.status === 201) {
          setShowUser(false)
          Swal.fire(
            'Deleted!',
            'User has been deleted.',
            'success'
          )
        }
        else {
          Swal.fire(
            'Error!',
            'User could not be deleted.',
            'error'
          )
        }
      }
      catch (err) {
        Swal.fire(
          'Error!',
          'User could not be deleted.',
          'error'
        )
      }
    }

    const handleToggleAdmin = async (user) => {
      try {
        const res = await axios.post(`${ADMIN_API}/toggleAdmin`, {
          StudentMobile: user.StudentMobile,
        })

        if (res.status === 201) {
          setShowUser(false)
          Swal.fire(
            'Success!',
            'User authority has been changed.',
            'success'
          )
        }
        else {
          Swal.fire(
            'Error!',
            'Cannot toggle authority.',
            'error'
          )
        }
      }
      catch (err) {
        Swal.fire(
          'Error!',
          'Cannot toggle authority.',
          'error'
        )
      }
    }

    return (
      <div className=''>
        <hr className='border-2 border-gray-900 mx-4' />
        <div>
          <div className='flex justify-center align-middle flex-col'>
            <p className='font-semibold text-gray-900 text-center sm:text-xl lg:font-extrabold'>Name - {detailUser.StudentName}</p>
            {detailUser.ifSuperAdmin ? <ChipIcon value="Super Admin" color="purple" /> : detailUser.ifAdmin ? <ChipIcon value="Admin" color="red" /> : <ChipIcon value="Student" color="blue" />}
            <p className='font-semibold text-gray-900 text-center sm:text-xl lg:font-extrabold'>Father's Name - {detailUser.StudentFatherName}</p>
            <p className='font-semibold text-gray-900 text-center sm:text-xl lg:font-extrabold'>Mobile Number - {detailUser.StudentMobile}</p>
            <p className='font-semibold text-gray-900 text-center sm:text-xl lg:font-extrabold'>Class - {detailUser.StudentClass}</p>
            <p className='font-semibold text-gray-900 text-center sm:text-xl lg:font-extrabold'>Email - {detailUser.StudentEmail}</p>
            <p className='font-semibold text-gray-900 text-center sm:text-xl lg:font-extrabold'>City - {detailUser.StudentCity}</p>
            {ifSuperAdmin ? (
              <div className='flex justify-center align-middle'>
                {/* if already admin or not */}
                {detailUser.ifAdmin ? (
                  <button
                    onClick={() => {
                      Swal.fire({
                        title: 'Are you sure?',
                        text: "Do you want to remove admin authority?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#4F46E5',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, remove it!'
                      }).then((result) => {
                        if (result.isConfirmed) {
                          handleToggleAdmin(detailUser)
                        }
                      }
                      )
                    }}
                  >
                    <ChipIcon value="Remove from Admin" color="red" />
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      Swal.fire({
                        title: 'Are you sure?',
                        text: "Do you want to make admin?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#4F46E5',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, make it!'
                      }).then((result) => {
                        if (result.isConfirmed) {
                          handleToggleAdmin(detailUser)
                        }
                      }
                      )
                    }}
                  >
                    <ChipIcon value="Make Admin" color="purple" />
                  </button>
                )}
              </div>
            ) : (null)}
          </div>




          <div className='flex justify-center align-middle flex-col'>
            <hr className='border-2 border-gray-900 mx-4' />
            <p className='text-3xl font-semibold text-gray-900 text-center m-2 p-2'>Test History</p>
            <div className='flex align-middle justify-center flex-col'>

              {detailUser.TestHistory.length === 0 ? <div className='text-xl font-semibold text-gray-900 text-center m-2 p-2'>Student has given no test yet</div> :
                <div className='flex flex-wrap justify-center align-middle gap-4 '>
                  {detailUser.TestHistory.map((test) => (
                    <SimpleCard
                      testDate={test.date}
                      testId={test.testId}
                    />
                  ))}
                </div>}
            </div>
          </div>
        </div>

        <div className='m-4'>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'blue',
                cancelButtonColor: '#F8333C',
                confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
                if (result.isConfirmed) {
                  handleDeleteUser(detailUser)
                }
              }
              )
            }}
            className="px-2 py-2 border space-x-3 flex flex-row text-base font-medium rounded-md shadow-sm text-white bg-red-500 hover:bg-red-700 fixed bottom-1 right-1 sm:bottom-4 sm:right-4"
          >
            <AiFillDelete className='scale-150 m-2 text-white' />
            <span className='sm:inline-block hidden'>Delete User</span>
          </button>
        </div>
        <div className='m-4'>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setShowUser(false)
            }}
            className='px-2 py-2 border space-x-3 flex flex-row text-base font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-700 fixed bottom-1 left-1 sm:bottom-4 sm:left-4'
          >
            <BiArrowBack className='scale-150 m-2' />
            <span className='sm:inline-block hidden'>Go Back</span>
          </button>
        </div>

      </div>
    )

  }


  const Icon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-5 w-5"
      >
        <path
          fillRule="evenodd"
          d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
          clipRule="evenodd"
        />
      </svg>
    );
  }

  const ChipIcon = ({ value, color = "blue" }) => {
    return (
      <div className='flex justify-center align-middle'>
        <Chip value={value} variant="ghost" color={color} icon={<Icon />} />
      </div>
    );
  }


  const SimpleCard = ({ testDate = "DD/MM/YYYY", testId }) => {
    const [testName, setTestName] = useState("-")
    const [testScore, setTestScore] = useState("-/-")

    const getDetails = async () => {
      try {
        const res = await axios.get(`${ADMIN_API}/getAllTest/${testId}`);
        // console.log(res.data.foundTest.TestInfo.TestName);
        setTestName(res.data.foundTest.TestInfo.TestName);
        const responses = detailUser.TestHistory.filter((test) => test.testId === testId)[0].responses;
        const actual = res.data.foundTest.QuestionSet;
        calculateScore(actual, responses);
      }
      catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    }

    const calculateScore = (actual, responses) => {
      let score = 0;
      responses.map((response, index) => {
        if (response.Response.status === 0) {
          score += 0;
        }
        else {
          if (actual[index].QuestionType === "Integer Type Answer") {
            if (parseInt(response.Response.IntegerAnswer) === parseInt(actual[index].IntegerAnswer)) {
              score += 4;
            }
          }
          else if (actual[index].QuestionType === "Single Correct Option") {
            let ansIndex = 0;
            const temp = actual[index].Options.map((option, index) => {
              if (option.IsAnswer) {
                ansIndex = index + 1;
              }
            }
            )
            if (response.Response.Options[0] === ansIndex) {
              score += 4;
            }
            else {
              score--;
            }
          }
          else if (actual[index].QuestionType === "Multiple Correct Option") {
            let resStr = "";
            let responseArray = response.Response.Options.map((option) => {
              resStr += option;
            }
            )
            let actStr = "";
            let actualArray = actual[index].Options.map((option, index) => {
              if (option.IsAnswer) {
                actStr += (index + 1);
              }
            }
            )
            resStr = resStr.split('').sort().join('');
            actStr = actStr.split('').sort().join('');

            if (resStr === actStr) {
              score += 4;
            }
            else {
              score--;
            }
          }
        }
      })
      setTestScore(`${score}/${responses.length * 4}`)
    }

    useEffect(() => {
      getDetails()
    }, [])

    return (
      <Card className="mt-6 w-96 border-b-2 border ">
        <CardBody>
          <Typography variant="h5" color="blue-gray" className="mb-2">
            {testName}
          </Typography>
          <Typography>
            Score - {testScore}
          </Typography>
          <Typography>
            Date - {testDate}
          </Typography>
        </CardBody>

      </Card>
    );
  }


  return (
    <div>
      <Navbar />
      <h1 className="text-2xl font-semibold text-gray-900 text-center ">Users List</h1>
      <h2 className='text-center text-xs'>{ifSuperAdmin ? "Super Admin" : "Admin"} Panel</h2>
      {showUser ? <DetailUser /> : <StudentList />}
    </div>
  )
}

export default User
